module.exports = __webpack_public_path__ + "img/web1.cd925bca.png";